import React, { Component } from 'react';
import AtcAutocomplete from '~/MedicinalBrandsAnalytics/AtcAutocomplete/AutocompleteContainer';
import FilterParameter from '~/libs/FilterParameter/FilterParameter';
import FilterParameterDescription from '~/libs/FilterParameter/FilterParameterDescription';
import DatePickerInput from '~/UI/DatePickerInput/DatePickerInput';
import Input from '~/UI/Input/Input';
import Select from '~/UI/Select/Select';

import styles from './styles.less';

interface Props {
	parameters: FilterParameterDescription<string | string[]>[];
	autocomplete: (reactProps: React.ComponentProps<typeof AtcAutocomplete>) => React.ReactElement;
	parameter: FilterParameter<string | string[]>;
	onChange(parameterName: string, parameterValue: any): void;
}

interface State {
	autocompleteValue: string;
}

export default class ParameterInput extends Component<Props, State> {
	static defaultProps = {
		autocomplete: null,
	};

	state = {
		autocompleteValue: '',
	};

	renderInput() {
		const { parameters, parameter, autocomplete } = this.props;
		const availableParameter = parameters.find((availableParameter) => availableParameter.name === parameter.name);

		if (autocomplete !== null) {
			return this.renderAutocomplete();
		}
		if (availableParameter?.isDate() ?? false) {
			return (
				<DatePickerInput
					dateValue={parameter.parseDateValue()}
					disabledDays={{ after: new Date() }}
					styles={{ default: styles.input, invalid: styles.input }}
					value={parameter.value}
					onChange={this.handleDateValueChange}
				/>
			);
		}
		return (
			<Input
				name={`filter-form-${parameter.name}`}
				styles={{ default: styles.input, invalid: styles.input }}
				value={parameter.value === null ? '' : parameter.value}
				onChange={this.inputChanged}
			/>
		);
	}

	renderAutocomplete() {
		const {
			props: { autocomplete, parameter },
			state: { autocompleteValue },
		} = this;

		return autocomplete({
			name: `filter-form-${parameter.name}`,
			value: autocompleteValue,
			selectedIds: parameter.value,
			onChange: (value: string) => this.setState({ autocompleteValue: value }),
			onSelect: this.optionSelected,
			inputStyles: { input: styles.input },
		});
	}

	handleParameterNameChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
		this.props.onChange(event.target.value, this.props.parameter.value);
	};

	inputChanged = (event: React.FormEvent<HTMLInputElement>) => {
		const { parameter, onChange } = this.props;
		onChange(parameter.name, event.currentTarget.value);
	};

	optionSelected = (value: { id: string }[]) => {
		const { parameter, onChange } = this.props;
		this.setState({ autocompleteValue: '' });
		onChange(
			parameter.name,
			value.map((option) => option.id)
		);
	};

	handleDateValueChange = (value: string) => {
		this.props.onChange(this.props.parameter.name, value);
	};

	render() {
		const { parameters, parameter } = this.props;

		return (
			<div className={styles.searchitem}>
				<Select styles={styles} value={parameter.name} onChange={this.handleParameterNameChange}>
					{parameters.map((availableParameter) => {
						const disabled = availableParameter.disabled && parameter.name !== availableParameter.name;
						return (
							<option disabled={disabled} key={availableParameter.name} value={availableParameter.name}>
								{availableParameter.label}
							</option>
						);
					})}
				</Select>
				<div className={styles.inputContainer}>{this.renderInput()}</div>
			</div>
		);
	}
}
